const lang = {
  state: {
    lang: localStorage.getItem("lang-select") || 'chinese',
  },
  mutations: {
    setLang(state, value) {
      localStorage.setItem('lang-select', value)
      state.lang = value;
    },
  },
  actions: {
  },
  getters: {
  },
}

export default lang;



// WEBPACK FOOTER //
// ./src/store/modules/lang/index.js